module.exports = __webpack_public_path__ + "media/images/app/homepage/weddings/brides-banner-ec4ad5589de9bbc838900ef5240c3273.webp";